import { LoadingPage } from '@/components/ui/loading-page';
import NavFrameBackdrop, { NAV_FRAME_RADIUS } from '@/components/scaffold/layout/NavFrameBackdrop';
import { NAV_DARK_FOCUS_RING } from '@/components/scaffold/layout/nav-dark';
import { useAuth } from '@/contexts/auth-context';
import { Box, Button, Flex, Text } from '@chakra-ui/react';
import { ShortLogo } from '@fluenceur/ui';
import { useTranslation } from 'react-i18next';
import { Link, Navigate, Outlet } from 'react-router-dom';

/** Account management must survive a downgrade or the loss of the selected brand. */
export default function AccountAssistantsLayout() {
  const { isAuthenticated, isLoading, user, logout } = useAuth();
  const { t } = useTranslation();
  if (isLoading) return <LoadingPage />;
  if (!isAuthenticated)
    return <Navigate to="/?returnTo=%2Fsettings%2Faccount%2Fassistants" replace />;
  return (
    <Box minH="100vh" position="relative">
      <NavFrameBackdrop top={0} />
      <Flex
        as="header"
        position="relative"
        color="white"
        px={{ base: 4, md: 6 }}
        py={4}
        justify="space-between"
        align="center"
        gap={4}
      >
        <Flex align="center" gap={5}>
          <ShortLogo height="24px" color="white" />
          <Text fontWeight="semibold">{t('settings.accountNav.group')}</Text>
        </Flex>
        {user?.currentBrandId ? (
          <Button
            asChild
            variant="outline"
            size="sm"
            color="white"
            borderColor="navDark.border"
            _focusVisible={NAV_DARK_FOCUS_RING}
          >
            <Link to="/settings/account/profile">{t('mcp.settings.back')}</Link>
          </Button>
        ) : (
          <Button
            variant="outline"
            size="sm"
            color="white"
            borderColor="whiteAlpha.400"
            _focusVisible={NAV_DARK_FOCUS_RING}
            onClick={() => void logout()}
          >
            {t('userMenu.logout')}
          </Button>
        )}
      </Flex>
      <Box
        as="main"
        position="relative"
        bg="white"
        borderTopLeftRadius={NAV_FRAME_RADIUS}
        minH="calc(100vh - 72px)"
        px={{ base: 4, md: 6 }}
        py={{ base: 6, md: 10 }}
      >
        <Box maxW="1000px" mx="auto">
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}
